import React from 'react';

const SubjectProgressBar = ({ stats, accentColor = '#4f46e5' }) => {
  if (!stats || stats.total === 0) return null;

  const { done, total, pct } = stats;
  const remaining = total - done;
  const isComplete = pct === 100;

  // SVG donut circle
  const r = 26;
  const circumference = 2 * Math.PI * r;
  const strokeOffset = circumference - (pct / 100) * circumference;
  const circleColor = isComplete ? '#16a34a' : accentColor;

  const pillsStyle = {
    display: 'flex',
    gap: '6px',
    marginTop: '8px',
  };

  return (
    <div style={{
      display: 'flex',
      alignItems: 'center',
      gap: '18px',
      background: 'rgba(255,255,255,0.96)',
      border: '1px solid rgba(0,0,0,0.07)',
      borderRadius: '16px',
      padding: '14px 20px',
      margin: '18px auto 0',
      width: '100%',
      maxWidth: '640px',
      boxShadow: '0 4px 20px rgba(0,0,0,0.10)',
    }}>
      {/* SVG Donut */}
      <div style={{ flexShrink: 0 }}>
        <svg width="68" height="68" viewBox="0 0 68 68">
          <circle cx="34" cy="34" r={r} fill="none" stroke="#e2e8f0" strokeWidth="5" />
          <circle
            cx="34" cy="34" r={r}
            fill="none"
            stroke={circleColor}
            strokeWidth="5"
            strokeLinecap="round"
            strokeDasharray={circumference}
            strokeDashoffset={strokeOffset}
            transform="rotate(-90 34 34)"
            style={{ transition: 'stroke-dashoffset 0.9s cubic-bezier(0.4,0,0.2,1)' }}
          />
          <text x="34" y="34" dominantBaseline="middle" textAnchor="middle"
            fontSize="11" fontWeight="800" fill={circleColor}>
            {pct}%
          </text>
        </svg>
      </div>

      {/* Label + bar + pills */}
      <div style={{ flex: 1, minWidth: 0 }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'baseline', marginBottom: '6px' }}>
          <span style={{ fontSize: '0.85rem', fontWeight: 700, color: '#1e293b' }}>
            {isComplete ? '\uD83C\uDF89 Course Complete!' : 'Overall Progress'}
          </span>
          <span style={{ fontSize: '0.8rem', fontWeight: 700, color: '#64748b' }}>
            {done}&nbsp;<span style={{ color: '#cbd5e1' }}>/</span>&nbsp;{total}
          </span>
        </div>

        {/* Track */}
        <div style={{ height: '7px', background: '#e2e8f0', borderRadius: '999px', overflow: 'hidden' }}>
          <div style={{
            height: '100%',
            width: `${pct}%`,
            background: isComplete
              ? 'linear-gradient(90deg,#22c55e,#16a34a)'
              : `linear-gradient(90deg,${accentColor}bb,${accentColor})`,
            borderRadius: '999px',
            transition: 'width 0.9s cubic-bezier(0.4,0,0.2,1)',
            minWidth: pct > 0 ? '6px' : '0',
          }} />
        </div>

        {/* Pills */}
        <div style={pillsStyle}>
          <span style={{
            fontSize: '0.7rem', fontWeight: 700, padding: '2px 10px', borderRadius: '20px',
            background: isComplete ? '#dcfce7' : '#eff6ff',
            color: isComplete ? '#16a34a' : accentColor,
          }}>
            {'✓'} {done} done
          </span>
          {remaining > 0 && (
            <span style={{
              fontSize: '0.7rem', fontWeight: 700, padding: '2px 10px', borderRadius: '20px',
              background: '#f8fafc', color: '#94a3b8', border: '1px solid #e2e8f0',
            }}>
              {remaining} remaining
            </span>
          )}
        </div>
      </div>
    </div>
  );
};

export default SubjectProgressBar;
